import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
    standalone: false
})
export class RoleComponent {
    constructor(private router: Router) { }

    navigateToPashuSakhi () {
        this.router.navigate(['/register']);
    }

    navigateToClfBookkeeper () {
        this.router.navigate(['/clf-bookkepper']);
    }

    navigateToKrishiSakhi () {
        this.router.navigate(['/krishi-sakhi']);
    }
}
